import { Menu, MenuItem } from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import React, { useState } from "react";
import { Button } from "components/ui";
import { Download, EllipsisVertical, Eye } from "lucide-react";
// import { fetchCsvData } from "utils/fetchCsvData";
import { useNavigate } from "react-router-dom";
import { DownloadCsvFile } from "utils/fetchCsvData";
import { openToast } from "store/slices/common/toast.slice";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";

const LogsActionBar = ({ row }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //--------------------------------------------------- Action Menu Array --------------------------------------
  const ActionMenuArray = [
    {
      label: "Download",
      icon: <Download size={16} color="#475569" />,
      onClick: () => {
        if (row?.file_url) {
          DownloadCsvFile(
            row.file_url,
            `${dayjs(Number(row.created_at)).format("DD/MM/YYYY")} Logs`
          );
        } else {
          dispatch(
            openToast({
              type: "error",
              message: `File not available to download.`,
            })
          );
        }
      },
    },
    {
      label: "View Log",
      icon: <Eye size={16} color="#475569" />,
      onClick: () => {
        navigate("day/allLogs", { state: { url: row.file_url } });
      },
    },
  ].filter(Boolean);

  // For action menu
  const [actionMenu, setActionMenu] = useState(null);
  const handleActionMenuOpen = (event) => {
    setActionMenu(event.currentTarget);
  };
  const handleActionMenuClose = () => {
    setActionMenu(null);
  };

  return (
    <MuiBox className="flex h-full items-center justify-center gap-3">
      <Button
        className="size-7"
        mode="icon"
        variant="ghost"
        onClick={handleActionMenuOpen}
      >
        <EllipsisVertical />
      </Button>
      <Menu
        anchorEl={actionMenu}
        open={Boolean(actionMenu)}
        onClose={() => handleActionMenuClose(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{
          " & .MuiMenu-paper": {
            mt: "10px",
            background: "#fff",
            boxShadow:
              "0 4px 6px -1px #e2e8f0, 0 2px 4px -2px #e2e8f0 !important",
          },
        }}
      >
        {ActionMenuArray.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => {
              handleActionMenuClose();
              option.onClick();
            }}
          >
            <MuiBox sx={{ display: "flex", alignItems: "center", gap: "9px" }}>
              <MuiBox sx={{ width: "fit-content" }}>{option.icon}</MuiBox>
              <MuiTypography
                sx={{ fontWeight: "500", fontSize: "13px", color: "#475569" }}
              >
                {option.label}
              </MuiTypography>
            </MuiBox>
          </MenuItem>
        ))}
      </Menu>
    </MuiBox>
  );
};

export default LogsActionBar;
